<template>
  <div
    class="tw-flex tw-items-center tw-gap-1.5"
    @mouseleave="handleMouseLeave"
  >
    <span
      v-for="rating in 5"
      :key="rating"
      :data-testid="`leave-review-stars-input-${rating}`"
      :class="getClass(rating)"
      @click="handleClick(rating)"
      @mouseenter="handleMouseEnter(rating)"
    />
  </div>
</template>

<script>
import getReviewStarInputIcon from '@/utils/getReviewStarInputIcon'

export default {
  name: 'LeaveReviewStarsInput',
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isHovered: false,
      hoveredValue: 0,
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    getClass(number) {
      const { value, hoveredValue, isHovered } = this
      const icon = getReviewStarInputIcon({
        number,
        value,
        hoveredValue,
        isHovered,
      })

      return `tw-cursor-pointer fa-star ${icon}`
    },
    handleMouseLeave() {
      this.hoveredValue = 0
      this.isHovered = false
    },
    handleMouseEnter(star) {
      this.hoveredValue = star
      this.isHovered = true
    },
    handleClick(rating) {
      this.model = this.model === rating ? 0 : rating
    },
  },
}
</script>
